import styled from 'styled-components';
import { mediumScreens } from 'components/common/fontElements';
import * as colors from 'components/common/colorConstants';

export const Container = styled.div`
  height: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
`;

export const InnerContainer = styled.div`
  padding: 60px 60px 70px;
  text-align: center;
  margin: 0px auto;
  flex: 1;
`;

export const Title = styled.p`
  padding: 0px 30px;
  font-family: 'Lato-Bold';
  margin-bottom: 0px !important;
  text-align: center;
  font-size: 14px;
  color: ${colors.black1};
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${mediumScreens}) {
    font-size: 12px;
  }
`;

export const Label = styled(Title)`
  text-align: left;
  padding: 0px 0px 10px;
`;

export const SubTitle = styled.p`
  padding: 0px 30px;
  font-family: 'Lato';
  margin: 0px 0px 50px;
  text-align: center;
  font-size: 14px;
  color: ${colors.black1};
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${mediumScreens}) {
    font-size: 12px;
  }
`;

export const SubText = styled(SubTitle)`
  margin: 0px 0px 20px;
  text-align: left;
  padding: 0px;
`;

export const Section = styled.div`
  padding: 0px 50px 50px;
  text-align: left;
`;

export const InstructionsSection = styled.div`
  margin: 20px auto 0px;
`;

export const Instructions = styled.div`
  width: 100%;
  border-radius: 5px;
  background-color: #f4f7f9;
  padding: 20px;
  margin: 10px 0px;
  font-size: 12px;
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${mediumScreens}) {
    font-size: 11px;
  }
`;
